export type RequestReportAxis = 'product' | 'canal' | 'supplier' | 'destination';

// Filters on dimensions other than the tab's own axis (e.g. Destination on
// the Produits tab). Never includes the filter matching the current axis -
// that one is already carried by the axis's own value/param.
export interface RequestReportCrossFilters {
  destinationIds?: number[];
  supplierIds?: number[];
  canals?: string[];
}

export interface RequestReportPeriod {
  label: string;
  days: number;
}

export const REQUEST_REPORT_DEFAULT_PERIOD_DAYS = 7;

export const REQUEST_REPORT_PERIODS: RequestReportPeriod[] = [
  { label: '7 jours', days: 7 },
  { label: '2 semaines', days: 14 },
  { label: '3 semaines', days: 21 },
  { label: '1 mois', days: 30 },
];

export const REQUEST_REPORT_CANALS = ['ORCHESTRA', 'REST'] as const;
